import React from 'react'
import { useSelector } from 'hooks/use-redux'
import type { ClientLibrary } from 'types/client-library'
import {
  BROWSE_LIBRARIES,
  IS_ARTIST,
  LIVE_LIBRARIES,
} from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getPrimaryClientLibrary } from '@disco/state-management/selectors/client-libraries'
import { DiscoCatalogLink } from './disco-catalog-link'
export const PlaylistPresentationPrimaryCatalog = (): React.ReactNode => {
  const isSupervisor = useFeatureEnabled(BROWSE_LIBRARIES)
  const isArtist = useFeatureEnabled(IS_ARTIST)
  const isDiscoverySuiteEnabled = useFeatureEnabled(LIVE_LIBRARIES)
  const primaryLibrary: ClientLibrary | null | undefined = useSelector(
    getPrimaryClientLibrary,
  )
  // Artist account (artist, supe plan) without Discovery Suite
  if ((isArtist || isSupervisor) && !isDiscoverySuiteEnabled) return null
  // Business account (non-artist, non-supe plan) without Discovery Suite
  const businessAccount = !isArtist && !isSupervisor

  if (businessAccount && !isDiscoverySuiteEnabled) {
    return <DiscoCatalogLink discoverySuiteEnabled={false} />
  }

  if (isDiscoverySuiteEnabled) {
    // DISCO (any plan) with a Primary Catalog set AND Discovery Suite
    if (primaryLibrary) {
      return (
        <DiscoCatalogLink
          catalog={{
            id: primaryLibrary.id,
            url: primaryLibrary.public_url,
            name: primaryLibrary.name,
            primary_shares: primaryLibrary.primary_shares,
          }}
          discoverySuiteEnabled
        />
      )
    }

    // Business account (non-artist, non-supe plan) without a primary catalog AND has Discovery Suite
    // TODO: check with product team if this is the correct behavior or this need to be extended to include any plan
    if (businessAccount && !primaryLibrary) {
      return <DiscoCatalogLink discoverySuiteEnabled />
    }
  }

  return null
}
